import React, { useState } from "react";
import '../App.css';
import HourlyParking from "../parkingForms/hourlyParking";
import MonthlyRental from "../parkingForms/monthlyRentalParking";
import DayRental from "../parkingForms/dayRentalParking";
// If using Font Awesome
import { FaClock, FaCalendarAlt, FaSun } from "react-icons/fa";

function VehicleEntry() {
  const [activeTab, setActiveTab] = useState("hourly");

  const tabConfig = [
    { key: "hourly", label: "Hourly Parking", icon: <FaClock /> },
    { key: "monthly", label: "Monthly Rental", icon: <FaCalendarAlt /> },
    { key: "day", label: "Day Rental", icon: <FaSun /> },
  ];

  const renderComponent = () => {
    switch (activeTab) {
      case "hourly":
        return <HourlyParking />;
      case "monthly":
        return <MonthlyRental />;
      case "day":
        return <DayRental />;
      default:
        return <HourlyParking />;
    }
  };

  return (
    <div className="vehicleEntry mt-3">
      <h2 className="mb-4">Vehicle Parking Entry</h2>
      <div className="container mt-3">
        <ul className="nav nav-tabs nav-justified custom-tabs">
          {tabConfig.map(tab => (
            <li className="nav-item" key={tab.key}>
              <button
                className={`nav-link custom-tab-btn ${activeTab === tab.key ? "active" : ""}`}
                onClick={() => setActiveTab(tab.key)}
                type="button"
              >
                <span className="me-2">{tab.icon}</span>
                {tab.label}
              </button>
            </li>
          ))}
        </ul>
      </div>
      <div className="mt-4">{renderComponent()}</div>
    </div>
  );
}

export default VehicleEntry;
